// ****************** ADDSTICKER **********************
export const addSticker = `QR/addSticker`;

// ****************** GETALLSTICKERS **********************
export const getAllSticker = `QR/getAllSticker`;

// // ****************** GETSTICKERBYCITY **********************
// export const getStickerByCity = `QR/getStickerByCity/${value}`;
